import { render, staticRenderFns } from "./BxKuncunInfoModal.vue?vue&type=template&id=fac50b3c&"
import script from "./BxKuncunInfoModal.vue?vue&type=script&lang=js&"
export * from "./BxKuncunInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports